import React from 'react';
import { Image, View } from "react-native"
import { BadgeProps } from "../../../store/types/soc_svc"


type BadgeCardProps = {
    badge:BadgeProps,
    size:number
}
const BadgeCard = ({ badge, size }:BadgeCardProps) => {

    return (
        <View style={{ borderRadius:100, backgroundColor:badge.badge_color }}>
            <Image
                source={{ uri: badge.badge_icon_url }}
                style={{ borderRadius:100, height:size, width: size }}
                resizeMode='cover'
                />
        </View>
    )
}

export default BadgeCard